export const bytesToMegabytes = (bytes: number) => {
  const megaBytes = bytes / (1024 * 1024);
  return Math.ceil(megaBytes).toString();
};
